import { AddOnOrderProps } from '../AddOnOrder';

const BrandAddOn = ({ orderData, setOrderData }: AddOnOrderProps) => {
  const handleBrandIdentity = () => {
    setOrderData({
      ...orderData,
      brandIdentity: !orderData.brandIdentity,
    });
  };

  const handleLogoDesign = () => {
    setOrderData({
      ...orderData,
      logoDesign: !orderData.logoDesign,
    });
  };

  return (
    <div>
      <p className="mt-8 text-base font-semibold text-primary-black">
        Need a brand? We’ve got you covered.
      </p>
      <div className="mt-4 flex items-start rounded-xl border border-[#CFD8E2] p-5">
        <input
          type="checkbox"
          className="h-[18px] w-[18px] checked:bg-black"
          checked={orderData.brandIdentity}
          onChange={handleBrandIdentity}
        />
        <div className="ml-3">
          <p className="text-sm font-semibold text-primary-black lg:text-base">
            Brand identity
          </p>
          <p className="mt-1.5 text-xs lg:text-sm">
            We’ll come up with the right colors, get nice fonts and design a
            logo that suits your business. You will receive a professional brand
            guideline perfect for building a great visual foundation.
          </p>
          <p className="mt-2 text-[10px] text-[#9FA6B0] lg:text-xs">
            Includes 2 revisions
          </p>
          <div className="my-3 border-b border-[#E3E8ED]" />
          <p className="text-sm font-bold text-primary-black lg:text-base">
            ₣1000
          </p>
        </div>
      </div>

      <p className="mt-8 text-base font-semibold text-primary-black">
        Just need a logo design?
      </p>

      <div className="mt-4 flex items-start rounded-xl border border-[#CFD8E2] p-5">
        <input
          type="checkbox"
          className="h-[18px] w-[18px] checked:bg-black"
          onChange={handleLogoDesign}
          checked={orderData.logoDesign}
        />
        <div className="ml-3">
          <p className="text-sm font-semibold text-primary-black lg:text-base">
            Logo Design
          </p>
          <p className="mt-1.5 text-xs lg:text-sm">
            We’ll design a logo that makes your business look sharp and
            professional.
          </p>
          <p className="mt-2 text-[10px] text-[#9FA6B0] lg:text-xs">
            Includes 2 revisions
          </p>
          <div className="my-3 border-b border-[#E3E8ED]" />
          <p className="text-sm font-bold text-primary-black lg:text-base">
            ₣500
          </p>
        </div>
      </div>
    </div>
  );
};

export default BrandAddOn;
